import { contactUs } from './contactUs'
import { dealerContact } from './dealerContact'
import { vehicleLead } from './vehicleLead'
import { feedback } from './feedback'

export const contactApi = {
  contactUs,
  dealerContact,
  vehicleLead,
  feedback
}